
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"77","height":"58","viewBox":"0 0 77 58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.54 20.6L12 41.5l.01.22h6.54l10-24.1h-6.76l-6 16.58-.7-3.58-.25-1.2-1.87-9.63a2.55 2.55 0 00-.92-1.55 3.16 3.16 0 00-2.06-.62H.11l-.11.41c1.075.247 2.129.582 3.15 1h.05l.19.08c.03.05.11.05.11.05l.19.08a.25.25 0 01.14.06c.067.018.13.045.19.08l.3.13.14.06.21.11a.27.27 0 01.14 0l.24.11a.27.27 0 01.14.05c.085.06.176.114.27.16l.08.06.38.22.38.21h.05c.067.03.13.068.19.11zM30.94 17.4L27 41.5h6.3l3.9-24.1h-6.26zM37.18 40.6a17.54 17.54 0 007.05 1.33l.03.01c4.29 0 10.74-2.22 10.74-8.22 0-3.783-3.189-5.502-5.718-6.865-1.664-.897-3.042-1.64-3.042-2.715 0-2.71 6.1-2.39 8.79-.9l.9-5.18A18.107 18.107 0 0050.29 17c-3.1 0-10.5 1.38-10.5 8 0 3.617 2.917 5.158 5.369 6.453 1.778.939 3.311 1.748 3.311 3.127 0 3.28-7.79 2.69-10.37.62l-.92 5.4z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M70.36 37.92l.74 3.58h5.74l-5-24.1h-5a2.88 2.88 0 00-2.9 1.79L54.58 41.5h6.48l1.3-3.58h8zm-.97-5.13h-5.15l3.28-9 1.87 9z"}})])
          )
        }
      }
    